import { AxiosResponse } from 'axios';
import { MutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { postRuleTester } from 'Services';
import { RQ_RULE_TESTER } from 'Utils';

type Options = {
    mutationOptions: Omit<MutationOptions<AxiosResponse, any, any, any>, 'mutationKey'>;
};

type MutationParams = {
    ruleId: number;
    startDt: Date;
    endDt: Date;
    conditions: string;
    actions: any;
    merchantId: string;
    tenantGroupId: string;
    ruleSetId: string;
    clientId: string;
    startDateString: string;
    endDateString: string;
};

function useRuleTester({ mutationOptions }: Options) {
    const queryClient = useQueryClient();

    const defaultSuccessHandler = () => {
        queryClient.invalidateQueries([RQ_RULE_TESTER]);
    };

    return useMutation([RQ_RULE_TESTER], (params: MutationParams) => postRuleTester(params), {
        ...mutationOptions,
        onSuccess: (data, variables, context) => {
            defaultSuccessHandler();
            mutationOptions.onSuccess?.(data, variables, context);
        },
        onError: async (error, variables, context) => mutationOptions.onError?.(error, variables, context)
    });
}

export default useRuleTester;
